import { render, staticRenderFns } from "./gameForm.vue?vue&type=template&id=e0648984&"
import script from "./gameForm.vue?vue&type=script&lang=js&"
export * from "./gameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports